document.addEventListener('DOMContentLoaded', () => {

  /**
   * Update picture element (sources + img)
   */
  function updatePicture(picture, src, srcset) {
    if (!picture) return;

    const sources = picture.querySelectorAll('source');
    const img = picture.querySelector('img');

    if (srcset) {
      sources.forEach(source => {
        source.srcset = srcset;
      });
    }

    if (img) {
      if (src) img.src = src;
      if (srcset) img.srcset = srcset;
    }
  }

  /**
   * Restore default image
   */
  function restorePicture(picture) {
    if (!picture) return;

    const defaultSrc = picture.dataset.defaultSrc;
    const defaultSrcset = picture.dataset.defaultSrcset;

    updatePicture(picture, defaultSrc, defaultSrcset);
  }

  /**
   * Handle hover
   */
  function handleHover(link, isEnter) {
    const panelId = link.dataset.promoPanel;
    if (!panelId) return;

    const panel = document.getElementById(panelId);
    if (!panel) return;

    const pictures = panel.querySelectorAll('picture[id]');
    if (!pictures.length) return;

    const hoverSrc = link.dataset.hoverImg;
    const hoverSrcset = link.dataset.hoverSrcset;
    const hoverUrl = link.dataset.hoverUrl;

    pictures.forEach((picture, index) => {
      const linkWrapper = panel.querySelector(`#${panelId}-link-${index + 1}`);

      if (isEnter) {
        updatePicture(picture, hoverSrc, hoverSrcset);
        if (linkWrapper && hoverUrl) {
          linkWrapper.href = hoverUrl;
        }
      } else {
        restorePicture(picture);
        if (linkWrapper) {
          const defaultHref = linkWrapper.dataset.defaultHref;
          if (defaultHref !== undefined) {
            linkWrapper.href = defaultHref || 'javascript:void(0)';
          }
        }
      }
    });
  }

  /**
   * Bind events
   */
  document.querySelectorAll('[data-promo-panel]').forEach(link => {
    link.addEventListener('mouseenter', () => handleHover(link, true));
    link.addEventListener('mouseleave', () => handleHover(link, false));
    link.addEventListener('focus', () => handleHover(link, true));
    link.addEventListener('blur', () => handleHover(link, false));
  });

});
